import React, { Component, ErrorInfo, ReactNode } from "react";

import { reportError } from "@companion-core/shared/app/Utils/errorReporting";

export interface ErrorBoundaryProps {
  children: ReactNode;
  fallback?: ReactNode | ((reset: () => void) => ReactNode);
  context?: string;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    reportError(error, {
      tags: { errorBoundary: this.props.context ?? "unknown" },
      contexts: { react: { componentStack: errorInfo?.componentStack ?? "" } },
    });
  }

  reset = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      const { fallback } = this.props;
      return <>{(typeof fallback === "function" ? fallback(this.reset) : fallback) ?? null}</>;
    }
    return <>{this.props.children}</>;
  }
}
